import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Suppress console errors for expected 401 responses (unauthenticated users)
// This prevents Lighthouse "browser errors" penalty for normal guest browsing
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Expected for unauthenticated users — don't log to console
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export function websiteChannelHeaders(channelOrigin) {
  return {
    "X-MaxEmployee-Channel-Origin": channelOrigin,
  };
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
